import ResponsiveTooltip from '../../ResponsiveTooltip';
import BarChartIcon from '@mui/icons-material/BarChart';
import React from 'react';
import { alpha } from '@mui/material/styles'; // Kept for tooltip styling
import { useTransactionTooltipData } from '../../../hooks/useTransactionTooltipData.tsx';

interface TransactionInfoIconProps {
    allTimeTransactionCount: number;
    transactionCount: number;
    planLimit: number;
    selectedYear: string;
}

const TransactionInfoIcon: React.FC<TransactionInfoIconProps> = ({ 
    allTimeTransactionCount,
    transactionCount, 
    planLimit, 
    selectedYear 
}) => {
    const {
        tooltipContent,
        theme // theme is used for icon color and tooltip styling
    } = useTransactionTooltipData({ allTimeTransactionCount, transactionCount, planLimit, selectedYear });

    return (
        <ResponsiveTooltip 
            title={tooltipContent}
            arrow
            placement="bottom-end"
            componentsProps={{
                tooltip: {
                    sx: {
                        bgcolor: (theme) => alpha(theme.palette.background.paper, 0.9),
                        backdropFilter: 'blur(5px)',
                        color: theme.palette.text.primary,
                        boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                        border: '1px solid',
                        borderColor: theme.palette.divider,
                        borderRadius: 1,
                        p: 0,
                        maxWidth: 'none',
                        fontSize: '0.9rem',
                        fontWeight: 'bold',
                        '& .MuiTooltip-arrow': {
                            color: (theme) => alpha(theme.palette.background.paper, 0.9),
                        }
                    }
                },
                popper: {
                    sx: {
                        '& .MuiTooltip-tooltip': {
                            p: 0,
                        }
                    }
                }
            }}
        >
            <BarChartIcon 
                sx={{
                    fontSize: '1.5rem',
                    color: (theme) => theme.palette.text.secondary,
                    cursor: 'help',
                    ml: 0.5
                }} 
            />
        </ResponsiveTooltip>
    );
};

export default TransactionInfoIcon;
